import { useState } from "react";
import { Button } from "@/components/ui/button";
import { FaArrowRight } from "react-icons/fa";
import muj_logo from '../muj_logo.png';
import sdc_logo from '../sdc_logo.png';

export const AuthLayout = ({ children }) => {
  const [showGetStarted, setShowGetStarted] = useState(
  window.location.pathname === "/login" &&
  !window.location.search.includes("direct=true")
);

  return (
    <div className="relative min-h-screen h-fit w-full flex items-center justify-center hideScrollBars lg:py-8">
      <div className="absolute inset-0 h-full bg-white/30 backdrop-blur z-10" />

      {/* Main content */}
      <div className="relative z-20 flex flex-row w-full max-w-6xl mx-auto rounded-lg shadow-lg  overflow-x-hidden bg-white/60 backdrop-blur-md  max-lg:flex-col max-lg:rounded-none max-lg:shadow-none max-lg:bg-white/80 max-lg:backdrop-blur-sm max-lg:min-h-screen max-lg:h-full">

        {/* Desktop: Left Description */}
        <div className="flex flex-col justify-center items-start w-1/2 p-12 max-lg:hidden">
          <div className="flex justify-center items-center gap-2 mb-4">
            <img src={muj_logo} alt="Travel Buddy Logo" className="h-10 object-contain" />
            <div className='bg-zinc-600 h-10 w-[2px]' ></div>
            <img src={sdc_logo} alt="SDC Logo" className="h-10 object-contain" />
          </div>
          <span className="text-[2.5rem] font-bold leading-tight mb-2 text-gray-900">
            Manipal University Jaipur
          </span>
          <span className="text-[2.5rem] font-bold leading-tight mb-4 text-amber-500">
            Travel Buddy
          </span>
          <div className="text-richblack-600 text-lg max-w-xl">
            This platform is an exclusive resource for the people of MUJ.<br />
            It provides an easy and accessible way to pool vehicles and get co-passengers for the go.
          </div>
        </div>

        {/* Mobile/Tablet: Native-like Get Started Overlay */}
        <div className={`fixed inset-0 z-30 gap-8 bg-white flex-col justify-center items-center transition-all duration-500 max-lg:flex max-lg:h-screen max-lg:w-screen max-lg:rounded-none max-lg:shadow-none max-lg:p-0 ${showGetStarted ? 'opacity-100 pointer-events-auto flex' : 'opacity-0 pointer-events-none'} hidden`}>
          <div className="flex flex-col justify-center items-center" >
            <div className="flex justify-center items-center gap-2 mb-4">
              <img src={muj_logo} alt="Travel Buddy Logo" className="h-10 object-contain" />
              <div className='bg-zinc-600 h-10 w-[2px]' ></div>
              <img src={sdc_logo} alt="SDC Logo" className="h-10 object-contain" />
            </div>
            <span className="text-3xl font-bold leading-tight mb-1 text-gray-900 max-sm:text-2xl text-center drop-shadow">
              Manipal University Jaipur
            </span>
            <span className="text-3xl  leading-tight mb-3 text-amber-500 max-sm:text-2xl text-center drop-shadow">
              Travel Buddy
            </span>
            <div className="text-gray-700 text-base max-sm:text-sm max-w-lg text-center mb-4 font-medium">
              This platform is an exclusive resource for the people of MUJ.
              It provides an easy and accessible way to pool vehicles and get co-passengers for the go.
            </div>
          </div>
          <Button
            variant={"default"}
            className="hover:bg-amber-500 transition-colors duration-200 w-1/2 max-w-2xl"
            size={"lg"}
            onClick={() => setShowGetStarted(false)}
          >
            Get Started
            <FaArrowRight />
          </Button>
        </div>

        {/* Right: Form */}


          {/* Desktop: Always show form. Mobile: Only show after Get Started */}


          <div className={`flex flex-col items-center w-1/2 p-12 max-lg:w-full max-lg:p-3 max-sm:p-3 bg-white/80 max-lg:bg-transparent max-lg:flex-1 max-lg:justify-center`}>
          <div className={`w-full max-w-md max-sm:max-w-full transition-all duration-500 ${
            showGetStarted
    ? 'max-lg:opacity-0 max-lg:pointer-events-none max-lg:scale-95'
    : 'max-lg:opacity-100 max-lg:pointer-events-auto max-lg:scale-100'
    }`}>

  {/* Mobile branding — directly above Login/Register */}
  <div className="hidden max-lg:flex flex-col items-center mb-3">
    
    <div className="flex justify-center items-center gap-2 mb-1">
      <img
        src={muj_logo}
        alt="MUJ Logo"
        className="h-8 object-contain"
      />

      <div className="bg-zinc-600 h-8 w-[2px]" />

      <img
        src={sdc_logo}
        alt="SDC Logo"
        className="h-8 object-contain"
      />
    </div>

    <h1 className="text-xl max-sm:text-lg font-bold text-gray-900 text-center leading-tight">
      Manipal University Jaipur
    </h1>

    <h2 className="text-xl max-sm:text-lg font-bold text-amber-500 text-center leading-tight">
      Travel Buddy
    </h2>
  </div>

  {/* Login / Register */}
  {(showGetStarted && window.innerWidth <= 1024) ? null : children}
  </div>
        </div>
      </div>
    </div>
  );
};
